module.exports = __webpack_public_path__ + "img/nav-header-mobile-eternity.97c4f4f.webp";